import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { createBrowserHistory, parseHref } from "@tanstack/history";
import { routeTree } from "./routeTree.gen";
import { pathForLocale, stripLocale } from "./i18n/locales";
import { detectLocale } from "./i18n/runtime";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 30_000 } },
  });

  const browserHistory =
    typeof window === "undefined"
      ? null
      : createBrowserHistory({
          parseLocation: () =>
            parseHref(
              `${stripLocale(window.location.pathname)}${window.location.search}${window.location.hash}`,
              window.history.state,
            ),
          createHref: (path) => {
            const url = new URL(path, window.location.origin);
            url.pathname = pathForLocale(url.pathname, detectLocale());
            return `${url.pathname}${url.search}${url.hash}`;
          },
        });

  const router = createRouter({
    routeTree,
    ...(browserHistory ? { history: browserHistory } : {}),
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  // Dehydrates the server query cache into the HTML payload so SSR-rendered
  // public content (boards, categories, listings) survives hydration instead
  // of flashing back to an empty client shell.
  setupRouterSsrQueryIntegration({ router, queryClient });

  return router;
};

